import { pickT } from "@repo/shared";
import type { Translated } from "@repo/shared/types";
import { T } from "./csv-parse-error.i18n";
import type { CsvParseError } from "./csv-utils";

/**
 * The "Line N: reason" text for a failed strict parse, in `lang`. Used by
 * csv-file-parser and csv-text-parser, which pass the language their own words
 * are read in (`useUserLanguage()`).
 */
export function csvLineErrorMessage(
  error: CsvParseError,
  lineNumber: number,
  lang: string,
): string {
  const t = pickT(T, lang);
  return t.line({ line: lineNumber, reason: reasonText(t, error) });
}

function reasonText(t: Translated<typeof T>, error: CsvParseError): string {
  switch (error.kind) {
    case "syntax":
      return t.errors.syntax(error.detail);
    case "header":
      return t.errors.header(error.got);
    case "missing_value":
      return t.errors.missingValue;
    case "invalid_date":
      return t.errors.invalidDate(error.value);
    case "invalid_value":
      return t.errors.invalidValue(error.value);
    case "not_increasing":
      return t.errors.notIncreasing({ date: error.date, previous: error.previous });
    case "no_data":
      return t.errors.noData;
  }
}
